import script from "./HomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=27543790&scoped=true&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4+webpack@5.87.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27543790"]])

export default __exports__